import { Component,ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { ViewWillEnter,IonContent  } from "@ionic/angular";
import { WebOrderService } from '../../services/web-order.service';
import { ToasterService } from "../../../../common/services/toaster.service";
import { RequestParams } from '../../../../common/rest-api/models/request-params';
@Component({
  selector: 'app-web-product-admin-page',
  templateUrl: 'web-product-admin.page.html',
  styleUrls: [
    './web-product-admin.page.scss',
  ]
})
export class WebProductAdminPage {
  settingsFields:any[];
  systemSetting:any[];
  rows:any;
  totalPages:number;
  currPage:number;
   currentRoute: string;
  productCode:string;
  requestParams: any;
    totalElements: number = 0;
    pageSize: number;
  @ViewChild('content', { static: false }) content: IonContent;
  loading:boolean=true ;
    constructor(
        private webOrderService: WebOrderService,
        private toasterService: ToasterService,
        private router:Router
      ) { 
  this.currentRoute = null;
    }
 ngOnInit() {
    this.currentRoute = this.router.url;
   this.loadData();
  }
  async ionViewWillEnter():Promise<void> {
   this.loadData();
   this.rows=[... this.rows];
}
  getWebProduct(){
    this.loadData();
  }
  async loadData() {
    this.rows = [];

    this.currPage = 1;
    this.pageSize = 500;
     this.requestParams = new RequestParams();
     delete this.requestParams.filters.ProductCode;
     
     if(this.productCode!=null && this.productCode!=""){
     this.requestParams.filters.ProductCode= this.productCode;
     }
       this.requestParams.setPaging(this.currPage, this.pageSize);
    this.loading=false;
    var products=await this.webOrderService.getWebProductAdmin(this.requestParams);
      
    if(products!=null){
      this.totalElements = products.totalRecords;
      this.totalPages = products.totalPages;
      this.rows = products.results;
      }
    this.loading=true;

    }
  toggleSelection(setting: any, event: any) {
    setting.data = event.detail.checked;
  }

   async setPage(page): Promise<void> {
    this.loading=false;
    this.currPage = page + 1;
    await this.loadData();
     this.content.scrollToTop(500);
     this.loading=false;
  }
}